import React, { useState, useEffect } from 'react'
import { Disclosure, Listbox } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { useLocation } from '@reach/router'
import queryString from 'query-string'
import { navigate } from 'gatsby'

const ListboxFilterItem = ({
  item,
  updateFilters,
  filteredProductTags,
  selectedFilter,
  productAmount,
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  function initialStateForCategory() {
    const queryParams = queryString.parse(location.search)
    const filters = queryParams[item.slug]
      ? queryParams[item.slug].split(',').map(decodeURIComponent)
      : []

    return filters
  }

  const selectedFilterForCategory = selectedFilter.find(
    (filter) => item.slug === filter.category
  )
  const categoryFilters = selectedFilterForCategory?.filters || []

  useEffect(() => {
    setActiveFilters(initialStateForCategory)
  }, [location])

  useEffect(() => {
    setActiveFilters(categoryFilters)
  }, [selectedFilter])

  const [activeFilters, setActiveFilters] = useState(initialStateForCategory)

  const toggleFilter = (filter) => {
    let newArray = [...activeFilters]
    const index = newArray.indexOf(filter)
    if (index !== -1) {
      newArray.splice(index, 1)
    } else {
      newArray.push(filter)
    }
    setActiveFilters(newArray)
    updateFilters(item.slug, newArray)
  }

  if (!item) return null

  return (
    <div className="product-overview-block-sidebar-filter-item">
      <div className="accordion">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={`btn accordion-toggle ${open ? 'open' : ''}`}
              >
                {item.title}
              </Disclosure.Button>
              <Disclosure.Panel className="accordion-menu show">
                {item.tags?.map((tag, index) => {
                  if (
                    filteredProductTags?.[item.slug]?.includes(tag.slug) ||
                    productAmount === 0
                  ) {
                    return (
                      <button
                        onClick={() => toggleFilter(tag.slug)}
                        key={index}
                        className={`accordion-item`}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={activeFilters.includes(tag.slug)}
                          onChange={() => toggleFilter(tag.slug)}
                          name={tag.slug}
                          value={tag.slug}
                        />
                        <span>{tag.title}</span>
                      </button>
                    )
                  } else {
                    return (
                      <button
                        disabled
                        key={index}
                        className={`accordion-item disabled`}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={activeFilters.includes(tag.slug)}
                          onChange={() => toggleFilter(tag.slug)}
                          name={tag.slug}
                          value={tag.slug}
                        />
                        <span>{tag.title}</span>
                      </button>
                    )
                  }
                })}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  )
}

export default ListboxFilterItem
